﻿import $ from "./dQuery";

$(function () {
    $('.surface-video').on('click',
        function(e) {
            var video = $(e.currentTarget).find('video').elements[0];

            if (video.paused) {
                video.play();
                $(e.currentTarget).addClass('playing');
            } else {
                video.pause();
                $(e.currentTarget).removeClass('playing');
            }

            e.preventDefault();
            console.log('playing');
        });
});